import React, { PropsWithChildren } from 'react';

const NoSSR = ({ children }: PropsWithChildren) => <>{children}</>;
export default NoSSR;
